import { render, staticRenderFns } from "./SidebarRequisitos.vue?vue&type=template&id=4889f77e&"
import script from "./SidebarRequisitos.vue?vue&type=script&lang=js&"
export * from "./SidebarRequisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports